import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'reactstrap';

const OnboardingStepHeader = ({
  handleOpen, isOpen, collapse, isCompleted, title, subtitle,
}) => (
  <>
    {/* eslint-disable jsx-a11y/click-events-have-key-events */}
    {/* eslint-disable jsx-a11y/no-static-element-interactions */}
    <div
      className={classnames('onboarding-step-header', { 'onboarding-step-header-completed': isCompleted })}
      onClick={() => handleOpen(!isOpen)}
    >
      {/* eslint-ensable jsx-a11y/click-events-have-key-events */}
      {/* eslint-ensable jsx-a11y/no-static-element-interactions */}
      <div>
        <div
          className={classnames('onboarding-step-icon', { 'onboarding-step-icon-completed': isCompleted })}
        >
          <i className="fal fa-check onboarding-step-complete-icon" />
          <i className="fal fa-xmark onboarding-step-incomplete-icon" />
        </div>
        <div className="onboarding-step-title">
          <h4>
            {title}
          </h4>
          <p>
            {subtitle}
          </p>
        </div>
      </div>
      <div>
        {collapse && (
          <Button color="link">
            <i className={classnames('fal fa-chevron-down', { 'fa-rotate-180': isOpen })} />
          </Button>
        )}
      </div>
    </div>
  </>
);

OnboardingStepHeader.propTypes = {
  handleOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  collapse: PropTypes.bool,
  isCompleted: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

OnboardingStepHeader.defaultProps = {
  handleOpen: () => {},
  isOpen: false,
  collapse: true,
};

export default OnboardingStepHeader;
